/**
 * Created by hernanherreros on 2019-07-23
 */

import * as React from 'react'
import styled from 'styled-components'
import { Trans } from '@lingui/macro'
import { Modal } from 'antd'

interface Props {
  imageURL: string;
  name: string;
  biography: string;
}

export default function SpeakerBadge ({ imageURL, name, biography }: Props) {
  const onClick = () => {
    Modal.info({
      title: <Trans>Biografía</Trans>,
      content: (
        <div>
          <ImageWrapperLeft>
            <img src={imageURL} alt={name}/>
          </ImageWrapperLeft>
          <p>{biography}</p>
        </div>
      ),
      onOk() {},
    });
  }

  return (
    <Container>
      <ImageWrapper>
        <img src={imageURL} alt={name}/>
      </ImageWrapper>
      <span>{name}</span>
      <BiographyButton onClick={onClick}><Trans>Ver biografía</Trans></BiographyButton>
    </Container>
  )
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  
  margin: 10px;
  border-radius: 5px;
  box-shadow: 0px 7px 18px rgba(109, 131, 148, 0.2);
  width: 120px;
  overflow: hidden;
  
  span {
    margin: 0 auto;
    text-align: center;
    font-weight: 300;
    padding: 10px;
    flex: 1;
    
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const ImageWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  background-color: #fbfbfb;
  
  img {
    width: 80px;
    height: 80px;
    border-radius: 40px;
  }
`

const ImageWrapperLeft = styled.div`
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  
  img {
    width: 120px;
    height: 120px;
    border-radius: 60px;
  }
`

const BiographyButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: 10px 0;
  cursor: pointer;
  
  color: #8397eb;;
  text-decoration: underline;
`